export default "__VITE_ASSET__Zqjwz6_d__"